:host {
  @apply block w-full h-full;
}

:host(.max-width-full) {
  @apply block w-full h-full;

  svg {
    @apply max-w-full;
  }
}

